import { render, staticRenderFns } from "./JcdcUtilityMenuFooter.vue?vue&type=template&id=313be58e"
import script from "./JcdcUtilityMenuFooter.vue?vue&type=script&lang=ts"
export * from "./JcdcUtilityMenuFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports